import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PinService } from '../../../../services/pin.service';
import { PinTypeEnum } from '../../../../enums/PinTypeEnum';
import { LoaderService } from '../../../../services/loader.service';
import { PopupService } from '../../../../services/popup.service';
import { Observable } from 'rxjs/Rx';
import { MyStuffService } from '../../../../services/my-stuff.service';

@Component({
  selector: 'app-pin-section',
  templateUrl: './pin-section.component.html',
  styleUrls: ['./pin-section.component.less']
})
export class PinSectionComponent implements OnInit {

  constructor(public pinService: PinService, public popupService: PopupService,
    public ref: ChangeDetectorRef, public loaderService : LoaderService, public myStuffService: MyStuffService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.allPins) {
      this.pinService.fetchPinsSource.next(true);
      this.myStuffService.myStuffSectionOpened.allPins = true;
    }
  }

  ngAfterViewInit() {
    this.pinService.addInputEventObservable();
  }

  getPinType(type) {
    if(type === PinTypeEnum.LABEL) {
      return 'label';
    } else if(type === PinTypeEnum.DOT) {
      return 'dot';
    } else if(type === PinTypeEnum.PIN) {
      return 'pin';
    } else if(type === PinTypeEnum.PIN_LABEL) {
      return 'pin with label';
    }
  }

  goToPin(mapPin) {
    this.popupService.updateRoute();
    (<any>window).pins.goToPin(mapPin.geom);
  }

  paginate() {
    this.pinService.fetchPins();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/pin-section/pin-section.component.ts